import { render, staticRenderFns } from "./PostEvidencePrevious.vue?vue&type=template&id=073479b6&scoped=true&"
import script from "./PostEvidencePrevious.vue?vue&type=script&lang=js&"
export * from "./PostEvidencePrevious.vue?vue&type=script&lang=js&"
import style0 from "./PostEvidencePrevious.vue?vue&type=style&index=0&id=073479b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073479b6",
  null
  
)

export default component.exports